import React from 'react';
import { Card } from '@repo/ui/Card';
import { Mercury } from '@repo/types/Models';
import MmsForwardForm from './MmsForwardForm';

export interface MmsForwardProps {
  didSwitch: Mercury.Models.Switch;
  canUpdate?: boolean;
  refetch: () => void;
}

const MmsForward = ({ didSwitch, refetch, canUpdate }: MmsForwardProps) => {
  return (
    <Card
      title="MMS forwards"
      description="Messages received by the gateway will be immediately forwarded by the protocol and to the endpoints specified below. If no protocol is selected messages will not be forwarded."
    >
      <div className="flex flex-col gap-8 mt-6">
        <MmsForwardForm didSwitch={didSwitch} refetch={refetch} canUpdate={canUpdate} />
      </div>
    </Card>
  );
};

export default MmsForward;
